__turbopack_context__.v({
  "badge": "OneySentence-module-scss-module__SOqjwW__badge",
  "downPayment": "OneySentence-module-scss-module__SOqjwW__downPayment",
  "header": "OneySentence-module-scss-module__SOqjwW__header",
  "infoIcon": "OneySentence-module-scss-module__SOqjwW__infoIcon",
  "logo": "OneySentence-module-scss-module__SOqjwW__logo",
  "payIn": "OneySentence-module-scss-module__SOqjwW__payIn",
  "paymentCost": "OneySentence-module-scss-module__SOqjwW__paymentCost",
  "root": "OneySentence-module-scss-module__SOqjwW__root",
});
